module.exports = __webpack_public_path__ + "img/fi-rr-shield-interrogation.bc5de943.svg";